<template>
  <div>

        <div style="height: 70px !important; width: 100%; border-radius: 25px 25px 0px 0px; font-size: 100%;display: flex;justify-content: flex-end;align-items: center;" 
         :style="bcgColor">
           <div
                style="margin-right:20px"         
             >
            <button icon @click="cancelClick" style="background: transparent;border: none;cursor:pointer !important;">
              <CloseIcon style="fill:#0247A7" />
            </button>
          </div>
        </div>
        <div
          :style="bdyColor"
          style=" width:100%;height: 91%"
          id="modalContainer"
        >
          <div style="width:100%;padding-top:20px;padding-bottom: 20px" >
            <span :style="titleProps">{{ titleText }}</span>
          </div>
          <div
            style="width:100%;display: flex;justify-content: center"
          >
            <div style="width: 92%;">
              <p :style="msgProps" class="ft_depend_height">{{ msgText }}</p>
            </div>
          </div>

          <div style="width:102.5%;">
          </div>

          <div style=" width:100%" v-if="(getTabHeader1 && getTabHeader2) || (getTabHeader1 && getTabHeader3) || (getTabHeader2 && getTabHeader3)">
            <div :style="bdyColor" >
              <div class="tabs" style="padding: 10px">
                <div class="tabitem" :class="{ activetab : activetab == '0' }" @click="activate('0')" v-if="getTabHeader1">
                  <a v-on:click="activetab='1'" v-bind:class="[ activetab == '0' ? 'active' : '' ]"><component v-bind:is="getTabHeader1" :style="bdyColor"></component></a>
                </div>
                <div class="vl" v-if="((getTabHeader1 && getTabHeader2) || (getTabHeader1 && getTabHeader3) || (getTabHeader2 && getTabHeader3)) && (getTabHeader1)"></div>
                <div class="tabitem" :class="{ activetab : activetab == '1' }" @click="activate('1')" v-if="getTabHeader2">
                  <a v-on:click="activetab='2'" v-bind:class="[ activetab == '1' ? 'active' : '' ]"><component v-bind:is="getTabHeader2" :style="bdyColor"></component></a>
                </div>
                <div class="vl" v-if="(getTabHeader1 && getTabHeader2 && getTabHeader3) || getTabHeader3"></div>
                <div class="tabitem" :class="{ activetab : activetab == '2' }" @click="activate('2')" v-if="getTabHeader3">
                  <a v-on:click="activetab='3'" v-bind:class="[ activetab == '2' ? 'active' : '' ]"><component v-bind:is="getTabHeader3" :style="bdyColor"></component></a>
                </div>
              </div>
            </div>
          </div>
<!--            /* with discount  */-->
          <div   style="width: 100%;display: flex;justify-content: center;margin-top: 12px" v-if="isDisc">
            <div  class="px-0" style="width: 90%">
              <div
                style="width:100%; border: 1px solid #C9CACB;"
                class="pa-0 my-0"
              >
                <div class="card">
                  <div class="card-front" data-image-position="left">
                    <div class="card-image card-image-left" style="background: rgb(78, 93, 107)">
                      <img :src="discImgSrc" />
                    </div>
                    <div class="card-content" :style="bdyColor" style="display: flex;flex-direction: column;justify-content: space-between;" v-if="!checkOptin">
                      <div class="d_flex_left">
<!--                        /*  content after submit COPY CODE*/-->
                       <span style="font-weight:bold; text-align: start !important;" class="pt-2 ml-3" :style="msgProps">
                       {{ dscntStmt }}
                       </span>
                      </div>
                          <div v-if="activetab ==='0'" class="tabcontent">
                            <div v-if="!loadReady && stateLoading" >
                              <div class="linear-progress-material small">
                                <div class="bar bar1"></div>
                                <div class="bar bar2"></div>
                              </div>
                            </div>
                            <div >
                              <div v-if="getTabHeader1 == 'FbIcon'" class="disc_block">                               
                                 <component v-bind:is="currentTabComponent" :style="bdyColor" > </component>                               
                              </div>
                              <div v-if="getTabHeader1 == 'WaIcon'">
                               
                                <vue-tel-input
                                  type="number"
                                  v-model="optinNumWhatsApp"
                                  v-bind="bindProps"
                                  v-on:country-changed="countryChanged"
                                  @onValidate="btnDisabled = $event.valid"
                                  @keydown="checkValidNumber($event)"
                                  required
                                  :placeholder="$t('settingsPage.addYourPhoneNumber')"
                                  label=""
                                  class="phone_number_section"
                                  style="width: 100% !important;"
                                  :class="{ 'alerts-border': displaeErr }"
                                  v-show="loadReady"
                                >

                                </vue-tel-input>
                              </div>
                              <div v-if="getTabHeader1 == 'SmsIcon'">
                                
                                <vue-tel-input
                                  type="number"
                                  v-model="optinNum"
                                  v-bind="bindProps"
                                  v-on:country-changed="countryChanged"
                                  @onValidate="btnDisabled = $event.valid"
                                  @keydown="checkValidNumber($event)"
                                  required
                                  :placeholder="$t('settingsPage.addYourPhoneNumber')"
                                  label=""
                                  class="phone_number_section"
                                  style="width: 100% !important;"
                                  :class="{ 'alerts-border': displaeErr }"
                                  v-show="loadReady"
                                >
                                </vue-tel-input>
                              </div>
                            </div>
                          </div>
                          <div v-if="activetab ==='1'" class="tabcontent">
                            <div v-if="!loadReady && stateLoading"  >
                              <div class="linear-progress-material small">
                                <div class="bar bar1"></div>
                                <div class="bar bar2"></div>
                              </div>
                            </div>
                            <div v-if="getTabHeader2 == 'FbIcon'" class="disc_block">                                                    
                                 <component v-bind:is="currentTabComponent" :style="bdyColor"> </component>                              
                            </div>
                            <div v-show="getTabHeader2 == 'WaIcon'">                             
                              <vue-tel-input
                                type="number"
                                v-model="optinNumWhatsApp"
                                v-bind="bindProps"
                                v-on:country-changed="countryChanged"
                                @onValidate="btnDisabled = $event.valid"
                                @keydown="checkValidNumber($event)"
                                required
                                :placeholder="$t('settingsPage.addYourPhoneNumber')"
                                label=""
                                class="phone_number_section"
                                style="width: 100% !important;"
                                :class="{ 'alerts-border': displaeErr }"
                                v-show="loadReady"
                              >
                              </vue-tel-input>
                            </div>
                            <div v-if="getTabHeader2 == 'SmsIcon'">                             
                              <vue-tel-input
                                type="number"
                                v-model="optinNum"
                                v-bind="bindProps"
                                v-on:country-changed="countryChanged"
                                @onValidate="btnDisabled = $event.valid"
                                @keydown="checkValidNumber($event)"
                                required
                                :placeholder="$t('settingsPage.addYourPhoneNumber')"
                                label=""
                                class="phone_number_section"
                                style="width: 100% !important;"
                                :class="{ 'alerts-border': displaeErr }"
                                v-show="loadReady"
                              >
                              </vue-tel-input>
                            </div>
                            </div>
                          <div v-if="activetab ==='2'" class="tabcontent">
                            <div
                              v-if="!loadReady && stateLoading">

                              <div class="linear-progress-material small">
                                <div class="bar bar1"></div>
                                <div class="bar bar2"></div>
                              </div>
                            </div>
                            <div v-if="getTabHeader3 == 'FbIcon'" class="disc_block">                                                           
                                <component v-bind:is="currentTabComponent" :style="bdyColor"> </component>                                  
                            </div>
                            <div v-if="getTabHeader3 == 'WaIcon'">                            
                              <vue-tel-input
                                type="number"
                                v-model="optinNumWhatsApp"
                                v-bind="bindProps"
                                v-on:country-changed="countryChanged"
                                @onValidate="btnDisabled = $event.valid"
                                @keydown="checkValidNumber($event)"
                                required
                                :placeholder="$t('settingsPage.addYourPhoneNumber')"
                                label=""
                                class="phone_number_section"
                                style="width: 100% !important;"
                                :class="{ 'alerts-border': displaeErr }"
                                v-show="loadReady"
                              >
                              </vue-tel-input>
                            </div>
                            <div v-if="getTabHeader3 == 'SmsIcon'">                            
                              <vue-tel-input
                                type="number"
                                v-model="optinNum"
                                v-bind="bindProps"
                                v-on:country-changed="countryChanged"
                                @onValidate="btnDisabled = $event.valid"
                                @keydown="checkValidNumber($event)"
                                required
                                :placeholder="$t('settingsPage.addYourPhoneNumber')"
                                label=""
                                class="phone_number_section"
                                style="width: 100% !important;"
                                :class="{ 'alerts-border': displaeErr }"
                                v-show="loadReady"
                              >
                              </vue-tel-input>
                            </div>              
                          </div>
                    <div>
                      <button type="submit"
                              :style="buttonProps"
                              :key="widgetKey"
                              class="sb_btn_in_card"
                               @click="subWithDisc"
                      >    {{ buttonText }}
                      </button>
                    </div>
                    </div>

            <div class="card-content"  :style="bdyColor" style="display: flex;flex-direction: column;justify-content: space-between;" v-if="checkOptin">
            
                <div style="width:100%; padding-left:12px;text-align:initial;">
                  <span style="font-weight:bold;font-size:17px; color:#5686F6" class="mt-2" >
                    {{ dscntCd }}
                  </span>
                </div>

                <div
                  style="width:100%; padding-left:12px;text-align:initial;">
                <span class="py-5" style="font-size:15px">
                  {{ dscntInstr }}
                </span>
                </div>
                <div style="width:100%; padding-left:12px;text-align:initial;">
                  <button
                    :style="buttonProps"
                    outlined
                    :key="widgetKey"
                    v-clipboard:copy="dscntCd"
                    v-clipboard:success="cpySuccess"
                    style="height:36px;"
                  >
                  <span :style="btnTextProps">
                    {{ cpyBtnTxt }}
                  </span>
                  </button>
                </div>
              
            </div>

                  </div>
                </div>

              </div>
            </div>
          </div>

<!--          /* no discount*/-->
          <div v-if="!isDisc" style="max-width: 440px;margin: 0 auto " >
            <div v-if="activetab ==='0'" class="tabcontent">
              <div v-if="!loadReady && stateLoading" >
                <div class="linear-progress-material small">
                  <div class="bar bar1"></div>
                  <div class="bar bar2"></div>
                </div>
              </div>
              <div >
                <div v-if="getTabHeader1 == 'FbIcon'" class="no_discount_fb">                                
                    <component v-bind:is="currentTabComponent" :style="bdyColor" class="width_fb_block" > </component>                  
                </div>
                <div v-if="getTabHeader1 == 'WaIcon'">
                 
                  <vue-tel-input
                    type="number"
                    v-model="optinNumWhatsApp"
                    v-bind="bindProps"
                    v-on:country-changed="countryChanged"
                    @onValidate="btnDisabled = $event.valid"
                    @keydown="checkValidNumber($event)"
                    required
                    :placeholder="$t('settingsPage.addYourPhoneNumber')"
                    label=""
                    class="phone_number_section"
                    style="width: 100% !important;"
                    :class="{ 'alerts-border': displaeErr }"
                    v-show="loadReady"
                  >
                  </vue-tel-input>
                </div>
                <div v-if="getTabHeader1 == 'SmsIcon'">                 
                  <vue-tel-input
                    type="number"
                    v-model="optinNum"
                    v-bind="bindProps"
                    v-on:country-changed="countryChanged"
                    @onValidate="btnDisabled = $event.valid"
                    @keydown="checkValidNumber($event)"
                    required
                    :placeholder="$t('settingsPage.addYourPhoneNumber')"
                    label=""
                    class="phone_number_section"
                    style="width: 100% !important;"
                    :class="{ 'alerts-border': displaeErr }"
                    v-show="loadReady"
                  >
                  </vue-tel-input>
                </div>                 
              </div>
            </div>
            <div v-if="activetab ==='1'" class="tabcontent">
              <div v-if="!loadReady && stateLoading"  >

                <div class="linear-progress-material small">
                  <div class="bar bar1"></div>
                  <div class="bar bar2"></div>
                </div>
              </div>
              <div v-if="getTabHeader2 == 'FbIcon'" class="no_discount_fb">                                    
                   <component v-bind:is="currentTabComponent" :style="bdyColor" class="width_fb_block"> </component>                
              </div>
              <div v-if="getTabHeader2 == 'WaIcon'">
                
                <vue-tel-input
                  type="number"
                  v-model="optinNumWhatsApp"
                  v-bind="bindProps"
                  v-on:country-changed="countryChanged"
                  @onValidate="btnDisabled = $event.valid"
                  @keydown="checkValidNumber($event)"
                  required
                  :placeholder="$t('settingsPage.addYourPhoneNumber')"
                  label=""
                  class="phone_number_section"
                  style="width: 100% !important;"
                  :class="{ 'alerts-border': displaeErr }"
                  v-show="loadReady"
                >

                </vue-tel-input>
              </div>
              <div v-if="getTabHeader2 == 'SmsIcon'">
               
                <vue-tel-input
                  type="number"
                  v-model="optinNum"
                  v-bind="bindProps"
                  v-on:country-changed="countryChanged"
                  @onValidate="btnDisabled = $event.valid"
                  @keydown="checkValidNumber($event)"
                  required
                  :placeholder="$t('settingsPage.addYourPhoneNumber')"
                  label=""
                  class="phone_number_section"
                  style="width: 100% !important;"
                  :class="{ 'alerts-border': displaeErr }"
                  v-show="loadReady"
                >
                </vue-tel-input>
              </div>              
            </div>
            <div v-if="activetab ==='2'" class="tabcontent">
              <div
                v-if="!loadReady && stateLoading">

                <div class="linear-progress-material small">
                  <div class="bar bar1"></div>
                  <div class="bar bar2"></div>
                </div>
              </div>
              <div v-if="getTabHeader3 == 'FbIcon'" class="no_discount_fb">              
                 <component v-bind:is="currentTabComponent" :style="bdyColor" class="width_fb_block"> </component>          
              </div>
              <div v-if="getTabHeader3 == 'WaIcon'">
                
                <vue-tel-input
                  type="number"
                  v-model="optinNumWhatsApp"
                  v-bind="bindProps"
                  v-on:country-changed="countryChanged"
                  @onValidate="btnDisabled = $event.valid"
                  @keydown="checkValidNumber($event)"
                  required
                  :placeholder="$t('settingsPage.addYourPhoneNumber')"
                  label=""
                  class="phone_number_section"
                  style="width: 100% !important;"
                  :class="{ 'alerts-border': displaeErr }"
                  v-show="loadReady"
                >

                </vue-tel-input>
              </div>
              <div v-if="getTabHeader3 == 'SmsIcon'">
               
                <vue-tel-input
                  type="number"
                  v-model="optinNum"
                  v-bind="bindProps"
                  v-on:country-changed="countryChanged"
                  @onValidate="btnDisabled = $event.valid"
                  @keydown="checkValidNumber($event)"
                  required
                  :placeholder="$t('settingsPage.addYourPhoneNumber')"
                  label=""
                  class="phone_number_section"
                  style="width: 100% !important;"
                  :class="{ 'alerts-border': displaeErr }"
                  v-show="loadReady"
                >
                </vue-tel-input>
              </div>

            </div>
            <div  style="height: 50px;width: 222px;margin: 10px auto 0px auto"  >
              <button type="submit"
                      :style="buttonProps"
                      :key="widgetKey"
                      class="sb_btn_in_card"
                      style="height:50px !important;"
                      @click="subNoDisc()"
              >    {{ buttonText }}
              </button>
            </div>
        </div>
          <div
            style="width:100%;cursor:pointer !important"
            v-if="!checkOptin"
            class="d_flex_center pad_y_23"
          >
            <a :style="cancelProps" @click="cancelClick">{{ cancelText }}</a>
          </div>

          <div
            style="width:100%"

            v-if="checkOptin"
            class="d_flex_center pad_y_23"
          >
            <a :style="cancelProps" @click="cancelClick" style="cursor:pointer !important">Close</a>
          </div>
        </div>

  </div>
</template>
<script>
import { mapGetters } from "vuex";
import MessengerCheckbox from "./MessengerCheckbox.vue";
import DummyDiv from "./DummyDiv.vue";
import Vue from "vue";
import SmsIcon from "@/assets/icons/sms-icon.svg";
import FbIcon from "@/assets/icons/facebook-icon.svg";
import WaIcon from "@/assets/icons/wa-icon.svg";
import CloseIcon from "@/assets/icons/close.svg";

export default {
  name: "WidgetCart",
  components: {
    MessengerCheckbox,
    DummyDiv,
    SmsIcon,
    WaIcon,
    FbIcon,
    CloseIcon,
  },
  data() {
    return {
      activetab:'0',
      dialog: false,
      btnId: 0,
      tab: null,
      optinNum: "",
      optinNumWhatsApp:"",
      discImg: require("@/assets/img/discount-icon.png"),
      didOptIn: false,
      cpyDone: false,
      btnDisabled: false,
      phone:"",
      bindProps: {
        mode: "international",
        placeholder: "Enter a phone number",
        required: false,
        enabledCountryCode: true,
        enabledFlags: true,
        autocomplete: "off",
        name: "telephone",
        maxLen: 25,
        inputOptions: {
          showDialCode: true
        },
        reg:null,
      },
      disButtonStyle:{
        "background-color":'rgba(0,0,0,.12)!important',
        "width": "100%",
      },
      bindPropsSec: {
        "background-color":'rgb(0, 106, 255) !important',
        "width": "60%",
        "margin":"0px auto"
      },
      disButtonStyleSec:{
        "background-color":'rgba(0,0,0,.12)!important',
        "width": "60%",
        "margin":"0px auto"
      },
      fbTab:false,
      loadReady:false,
      stateLoading:false,
    };
  },
  methods: {
    activate:function(el){
      this.activetab = el;
    },
    countryChanged(country) {
      setTimeout(()=> {this.optinNum == '' ? this.optinNum = '+' + country.dialCode : this.optinNum.length > 4 && this.first == true ? this.optinNum = '+' + country.dialCode: this.optinNum,
        this.btnDisabled = false},300)
      if(country.dialCode !== null){
        this.country = '+' + country.dialCode
      }
    },
    checkValidNumber(event){
      switch (event.code){
        case 'Backspace':

          break;
        case 'Delete':

          break;
        case 'ArrowUp':

          break;
        case 'ArrowDown':

          break;
        case 'ArrowLeft':

          break;
        case 'ArrowRight':

          break;
        default: (/[a-zA-Z]/).test( event.key) == true ? event.preventDefault() : ''
      }
    },
    incrBtnId() {
      this.btnId++;
    },
    toggleDialog() {
      this.dialog = !this.dialog;
    },
    resetChanges() {
      this.$store.dispatch("getWidgets");
    },
    cancelClick() {    
      setTimeout(() => { this.$store.commit('changeStatus',false) },200)      
    }, 
    subWithDisc(){       
        if(this.btnDisabled == true){
          this.actionSubmit()    
          this.didOptIn = true
        }else if(this.$store.getters.getCheckBoxState == "checked"){
              Vue.FB.AppEvents.logEvent("MessengerCheckboxUserConfirmation", null, {
              app_id: this.getMessengerId,
              page_id: this.getFbPgId,
              ref: this.$store.getters.getInstanceId,
              user_ref: this.$store.getters.getCheckBoxUserRef,
            });
             this.didOptIn = true    
          }else{         
          this.$store.dispatch("setErrFlashFB", true).then(() => {
          this.incrBtnId();
          setTimeout(() => {
            this.$store.dispatch("setErrFlashFB", false);
          }, 1000);
        });
      }    
    },
    subNoDisc(){       
        if(this.btnDisabled == true){
          this.actionSubmit()   
          this.cancelClick()
        }else if(this.$store.getters.getCheckBoxState == "checked"){
              Vue.FB.AppEvents.logEvent("MessengerCheckboxUserConfirmation", null, {
              app_id: this.getMessengerId,
              page_id: this.getFbPgId,
              ref: this.$store.getters.getInstanceId,
              user_ref: this.$store.getters.getCheckBoxUserRef,
            });
           this.cancelClick()
        }else{         
          this.$store.dispatch("setErrFlashFB", true).then(() => {
          this.incrBtnId();
          setTimeout(() => {
            this.$store.dispatch("setErrFlashFB", false);
          }, 1000);
        });
      }    
    },   
    actionSubmit(){
       if(this.optinNumWhatsApp.length > 5){        
            let obj = {
          instance_id: document.querySelector("widget-view").instance_id,
          cart_id: document.querySelector("widget-view").cart_id,
          user_ref: this.optinNumWhatsApp,
          };
          this.$store.dispatch("sendWaOptin", obj)     
       } else if(this.optinNum.length > 5){        
              let obj = {
            instance_id: document.querySelector("widget-view").instance_id,
            cart_id: document.querySelector("widget-view").cart_id,
            user_ref: this.optinNum,
            };
           this.$store.dispatch("sendSMSOptin", obj);           
       } else{
          if (this.$store.getters.getCheckBoxState == "checked") {
              Vue.FB.AppEvents.logEvent("MessengerCheckboxUserConfirmation", null, {
              app_id: this.getMessengerId,
              page_id: this.getFbPgId,
              ref: this.$store.getters.getInstanceId,
              user_ref: this.$store.getters.getCheckBoxUserRef,
            });
          }else {
                this.$store.dispatch("setErrFlashFB", true).then(() => {
                this.incrBtnId();
                setTimeout(() => {
                  this.$store.dispatch("setErrFlashFB", false);
                }, 1000);
              });
            }
       }
    },
    cpySuccess() {
      this.cpyDone = true;
      setTimeout(() => {
        this.cpyDone = false;
      }, 1500);
    },
  },
  computed: {
    ...mapGetters(["getWidgetsState", "getFbDetails", "getCheckBoxRendered"]),

    discImgSrc() {
      return  `${process.env.VUE_APP_CLOUD_STORAGE_URL}/widget/img/discount-icon.png`;
    },
    styleHeader1() {
      if (this.tab == 0) {
        return { opacity: 1 };
      } else {
        return { opacity: 0.3 };
      }
    },
    styleHeader2() {
      if (this.tab == 1) {
        return { opacity: 1 };
      } else {
        return { opacity: 0.3 };
      }
    },
    styleHeader3() {
      if (this.tab == 2) {
        return { opacity: 1 };
      } else {
        return { opacity: 0.3 };
      }
    },
    cpyBtnTxt() {
      if (this.cpyDone) {
        return "COPIED!";
      } else {
        return "COPY DISCOUNT CODE";
      }
    },
    displaeErr() {
      return this.$store.getters.getErrFlashFB;
    },
    telNumErr() {
      let obj = { "border-color": "#ff0000" };
      if (this.$store.getters.getErrFlashFB) {
        return obj;
      } else {
        return {};
      }
    },
    checkOptin() {
      return this.didOptIn;
    },
    isDisc() {
      return this.getWidgetsState.subscribe_type == "subscribe" ? true : false;
    },
    cardHeight() {
      return this.getWidgetsState.subscribe_type == "subscribe"
        ? "600px"
        : "600px";
    },

    retCpyDone() {
      return this.cpyDone;
    },
    getTabHeader1() {
      if (this.getWidgetsState.enabled_widgets.sms == 1) {
        return "SmsIcon";
      } else if(this.getWidgetsState.enabled_widgets.facebook == 1){
        return "FbIcon";
      } else if(this.getWidgetsState.enabled_widgets.whatsapp == 1){
        return "WaIcon";
      }return false
    },
    getTabHeader2() {
      if (this.getWidgetsState.enabled_widgets.sms == 2) {
        return "SmsIcon";
      } else if(this.getWidgetsState.enabled_widgets.facebook == 2){
        return "FbIcon";
      } else if(this.getWidgetsState.enabled_widgets.whatsapp == 2){
        return "WaIcon";
      }else return false
    },
    getTabHeader3() {
      if (this.getWidgetsState.enabled_widgets.sms == 3) {
        return "SmsIcon";
      } else if(this.getWidgetsState.enabled_widgets.facebook == 3){
        return "FbIcon";
      }else if(this.getWidgetsState.enabled_widgets.whatsapp == 3){
        return "WaIcon";
      }else return false
    },
    getTabKeyFb() {
      return this.getWidgetsState.enabled_widgets.facebook - 1;
    },
    getTabKeySMS() {
      return this.getWidgetsState.enabled_widgets.sms - 1;
    },
    getTabKeyWa() {
      return this.getWidgetsState.enabled_widgets.whatsapp - 1;
    },
    getMessengerId() {
      return this.getFbDetails.messenger_app_id;
    },
    getFbPgId() {
      return this.getFbDetails.page_id;
    },
    detectChange() {
      return this.getWidgetsState.changesSaved;
    },
    currentTabComponent() {
      if (this.getFbDetails.div_class == "fb-send-to-messenger") {
        return "MessengerCheckbox";
      } else {
        return "DummyDiv";
      }
    },
    bcgColor() {
      let hdrClsObj = {
        "background-color": this.getWidgetsState.header_background_color,
      };
      return hdrClsObj;
    },
    backBdyColor(){
      return this.getWidgetsState.popup_background_color
    },
    bdyColor() {
      let bdyClsObj = {
        "background-color": this.getWidgetsState.popup_background_color,
      };
      return bdyClsObj;
    },
    titleText() {
      return this.getWidgetsState.pop_up_title;
    },
    titleProps() {
      let ttlObj = {
        color: this.getWidgetsState.pop_up_title_font_color,
        "font-weight": this.getWidgetsState.pop_up_title_font_type,
        "font-size": this.getWidgetsState.pop_up_title_font_size + "px",
        "font-family": this.getWidgetsState.pop_up_title_font_family,
      };
      return ttlObj;
    },
    msgText() {
      return this.getWidgetsState.pop_up_message;
    },
    msgProps() {
      let ttlObj = {
        color: this.getWidgetsState.pop_up_message_font_color,
        "font-weight": this.getWidgetsState.pop_up_message_font_type,
        "font-size": this.getWidgetsState.pop_up_message_font_size + "px",
        "font-family": this.getWidgetsState.pop_up_message_font_family,
        "text-align": "center",
      };
      return ttlObj;
    },
    dscntStmt() {
      return this.getWidgetsState.discount_statement;
    },
    dscntCd() {
      return this.getWidgetsState.discount_code;
    },
    dscntInstr() {
      return this.getWidgetsState.apply_discount_instruction;
    },
    cancelText() {
      return this.getWidgetsState.pop_up_cancel;
    },
    cancelProps() {
      let ttlObj = {
        color: this.getWidgetsState.pop_up_cancel_font_color,
        "font-weight": this.getWidgetsState.pop_up_cancel_font_type,
        "font-size": this.getWidgetsState.pop_up_cancel_font_size + "px",
        "font-family": this.getWidgetsState.pop_up_cancel_font_family,
        "text-decoration": "underline",
        "text-align": "center",
      };
      return ttlObj;
    },
    buttonText() {
      this.incrBtnId();
      return this.getWidgetsState.button_text;
    },
    buttonProps() {
      let borderRad =
        this.getWidgetsState.button_corners == "Round" ? "4px" : "0px";
      let buttonObj = {
        "background-color": this.getWidgetsState.button_background,
        "border-color": this.getWidgetsState.button_border_color,
        "border-radius": borderRad,
        "border-width": this.getWidgetsState.button_border_size + "px",
        width: "100%",
      };
      return buttonObj;
    },
    btnTextProps() {
      let btnObj = {
        color: this.getWidgetsState.button_font_color,
        "font-family": this.getWidgetsState.button_font_family,
        "font-weight": this.getWidgetsState.button_font_type,
        "font-size": this.getWidgetsState.button_font_size + "px",
        "text-transform": "none",
      };
      return btnObj;
    },
    widgetType() {
      return this.getWidgetsState.facebook_widget_type;
    },
    widgetKey() {
      return "key" + this.getWidgetsState.wdgt_key_internal + "b" + this.btnId;
    },
    checkRendered() {
      return this.getCheckBoxRendered;
    },
  },
  watch:{
    optinNum(newVal){
      function isLetter(c) {
        return c.toLowerCase() != c.toUpperCase();
      }
      var str = newVal
      isLetter(str) == true ? this.btnDisabled = false : this.btnDisabled
      newVal == '' ? setTimeout(() => this.btnDisabled = false ,400): this.btnDisabled
    },
    fbTab(){
      this.loadReady = false
      setTimeout(() => this.loadReady = true ,300)
    }
  },
  mounted() {
    this.loadReady = false   
    setTimeout(() => this.loadReady = true ,3500)
    setTimeout(() => {
      this.stateLoading = true
      if(this.getTabHeader1 == false && this.getTabHeader2){
        this.activetab = '1'
      }
      } ,2000)


  },
  beforeCreate() {
    this.$store.dispatch("getWidgets");
    this.tab = "tab1";
  },
};
</script>

<style lang="scss">
$card-options: (
  primary: rgb(46, 160, 235),
  alert: rgb(255, 220, 115),
  success: rgb(137, 208, 133),
  warning: rgb(242, 154, 78),
  danger: rgb(250, 87, 87)
);


// ---
// Card container is the base `holder for cards`
// Card container can either be a card-group or card-columns
// The container can also be styled
//
// EXAMPLE:
//   <div class="card-container card-container-styled card-columns">
//     ...
//   <div>
// ---

// Base card container
.tabcontent{
  height: 80px;
  flex-direction: column;
  justify-content: center;
  display: flex;
}
.pad_y_23{
  padding-top: 23px;
  padding-bottom: 23px;
}
.vti__input {
  background-color: transparent !important;
  border-style: none;
  color: inherit;
}
.vti__country-code{
  display:none;
}
.sb_btn_in_card{
  height: 35px;
  color: #FFFFFF;
  cursor: pointer;
}
.d_flex_center{
  display: flex;
  justify-content: center;
}
.d_flex_left{
  display: flex;
  justify-content: left;
}
.card-container { margin-bottom: 40px; }
.card-container-header {
  margin-bottom: 10px;

  @media (min-width: 40em) {
    align-items: center;
    display: flex;
    justify-content: space-between;
  }
}

.card-container-title { margin-bottom: 0; }
.card-container-actions > a:not(:last-child) {
  margin-right: 10px;
}

.card-container-styled > .card-container-body {
  background: #eee;
  border: 1px solid #ddd;
  border-radius: 3px;
  box-shadow: 0 1px 5px 0 rgba(0, 0, 0, .1);
  padding: 20px 20px 0;
}

// Flex style card container
.card-group > .card-container-body {
  display: flex;
  flex-wrap: wrap;
}

// Masonary style card container
.card-columns > .card-container-body {
  column-count: 1;

  // Change count on larger screens
  @media (min-width: 40em) { column-count: 3; }
  @media (min-width: 60em) { column-count: 4; }
  @media (min-width: 80em) { column-count: 5; }

  // Make cards responsive
  > .card { max-width: 100%; }
}


// ---
// Cards are a simple inline element to hold content
// Cards can be flipped to store more information on the back
// ---
.card {
  display: inline-flex;
  position: relative;
  vertical-align: top;
  width: 100%;
}

// Basic front/back styles
.card-back,
.card-front {
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 3px;
  position: relative;
  width: 100%;

  // Adjust flex-direction if image is on left and right of card
  @media (min-width: 30em) {
    &[data-image-position='left'],
    &[data-image-position='right'] {
      flex-direction: row;
    }
  }
}

.card-front {
  display: flex;
  flex-direction: column;
}

// Make card images responsive
// 1. Fixes IE bug for oversized images in container
.card-image {
  min-height: 1px; // 1

  > img {
    border-radius: 3px;
    display: block;
    margin: auto;
    max-width: 100%;
  }

  &:not(:first-child):not(:last-child) {
    border-radius: 0;
  }
}

// 1. Fixes IE bug not respecting width of container
// 2. Fixes FF bug not respecting width of container
%card-image-side {
  width: 100%; // 1

  @media (min-width: 30em) {
    max-width: 28%; // 2
  }

  > img {
    height: 100%;
  }
}
.card-image-top > img { border-radius: 3px 3px 0 0; }
.card-image-bottom {
  order: 1;

  > img {
    border-radius: 0 0 3px 3px;
  }
}
.card-image-left {
  @extend %card-image-side;
}
.card-image-right {
  @extend %card-image-side;
  order: 1;
}

// Main content area
// 1. Write out shorthand for IE bugfix
.card-content {
  padding: 15px;
  flex: 1 1 auto; // 1
}

// Aditional action area
.card-actions {
  padding: 15px;

  > a {
    color: map-get($card-options, primary);
    font-size: .8571rem;
    text-decoration: none;

    &:not(:last-child) {
      margin-right: 10px;
    }

    &:hover {
      color: mix(#000, map-get($card-options, primary), 20%);
    }
  }
}


// ---
// Flippable cards need additional markup for front and back sides
// JS handles adding in the container
// ---
.card-flip-container {
  perspective: 1000px;
  width: 100%;

  // Common front and back styles
  > .card-back,
  > .card-front {
    backface-visibility: hidden;
    transition:
      opacity .35s cubic-bezier(.23, 1, .32, 1),
      transform .65s cubic-bezier(.23, 1, .32, 1);
    transform-style: preserve-3d;
  }

  // Position front on `top`
  > .card-front {
    transform: rotateY(0) translate3d(0, 0, 2px);
  }

  // Position back
  // 1. Sometimes back does not align to top of card properly
  > .card-back {
    height: 0;
    margin-top: -2px; // 1
    opacity: 0;
    overflow: hidden;
    transform: rotateY(-180deg);
    width: 0;
  }
}

// Hide front of card on flip
.card-flipped > .card-back {
  height: 100%;
  opacity: 1;
  overflow: visible;
  transform: rotateY(0);
  width: 100%;
}

// Show back of card on flip
.card-flipped > .card-front {
  height: 0;
  overflow: hidden;
  transform: rotateY(180deg) translate3d(0, 0, 2px);
  width: 0;
}

// Flip button
.card-flip-button {
  bottom: 2px;
  color: rgba(255, 255, 255, .7);
  display: block;
  font-size: 1.25rem;
  position: absolute;
  right: 5px;
  text-shadow: 0 1px 0 rgba(0, 0, 0, .3);
}


// ---
// Selectable cards need to be defined in the DOM
// ---
.card-selected > .card-front {
  background: map-get($card-options, primary);
  border-color: mix(#000, map-get($card-options, primary), 15%);
  box-shadow: inset 0 -4px 0 0 mix(#000, map-get($card-options, primary), 15%);
  color: #fff;
}

.card-selected .card-actions > a { color: #fff; }


// ---
// Text alignment overrides
// ---
.text-left { text-align: left !important; }
.text-center { text-align: center !important; }
.text-right { text-align: right !important; }


// ---
// Card state variants
// ---
.card-inverse { color: #fff; }
.card-inverse .card-actions > a { color: #fff; }
.card-primary > .card-back,
.card-primary > .card-front {
  background: map-get($card-options, primary);
  border-color: mix(#000, map-get($card-options, primary), 15%);
  box-shadow: inset 0 -4px 0 0 mix(#000, map-get($card-options, primary), 15%);
}
.card-alert > .card-back,
.card-alert > .card-front {
  background: map-get($card-options, alert);
  border-color: mix(#000, map-get($card-options, alert), 15%);
  box-shadow: inset 0 -4px 0 0 mix(#000, map-get($card-options, alert), 15%);
}
.card-success > .card-back,
.card-success > .card-front {
  background: map-get($card-options, success);
  border-color: mix(#000, map-get($card-options, success), 15%);
  box-shadow: inset 0 -4px 0 0 mix(#000, map-get($card-options, success), 15%);
}
.card-warning > .card-back,
.card-warning > .card-front {
  background: map-get($card-options, warning);
  border-color: mix(#000, map-get($card-options, warning), 15%);
  box-shadow: inset 0 -4px 0 0 mix(#000, map-get($card-options, warning), 15%);
}
.card-danger > .card-back,
.card-danger > .card-front {
  background: map-get($card-options, danger);
  border-color: mix(#000, map-get($card-options, danger), 15%);
  box-shadow: inset 0 -4px 0 0 mix(#000, map-get($card-options, danger), 15%);
}





.section {
  background: #f7f7f7;
  border-bottom: 2px solid #ddd;
  padding: 75px 50px;

  &:nth-child(even) {
    background: #fff;
  }
}

.section-info {
  margin-bottom: 50px;
  text-align: center;
}

.section-text {
  @media (min-width: 40em) {
    margin: auto;
    max-width: 700px;
  }
}


.subtitle { color: #999; }
.btn {
  background: map-get($card-options, primary);
  border: 1px solid mix(#000, map-get($card-options, primary), 10%);
  box-shadow: 0 3px 0 0 mix(#000, map-get($card-options, primary), 15%);
  border-radius: 3px;
  color: #fff;
  padding: 5px 8px;
  text-align: center;
}

</style>
<style>
.linear-progress {
  background: #bbdefb;
  height: 10px;
  position: relative;
  width: 50%;
  margin: 0 auto;
  margin-top: 2rem;
  overflow: hidden;
  -webkit-animation: start 0.3s ease-in;
  animation: start 0.3s ease-in;
}
.linear-progress.small {
  width: 50%;
  height: 2px;
}
.linear-progress .bar {
  position: absolute;
  background: #1565c0;
  transition: transform 0.2s linear;
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 50%;
}
.linear-progress .bar1 {
  -webkit-animation: progressLinearMovement 2.5s infinite;
  animation: progressLinearMovement 2.5s infinite;
  -webkit-animation-delay: 0;
  animation-delay: 0;
}
.linear-progress .bar2 {
  left: -100%;
  -webkit-animation: progressLinearMovement 2.5s infinite;
  animation: progressLinearMovement 2.5s infinite;
  -webkit-animation-delay: 0.7s;
  animation-delay: 0.7s;
}
.linear-progress-material {
  background: #aad1f9;
  height: 10px;
  position: relative;
  width: 50%;
  margin: 0 auto;
  margin-top: 2rem;
  overflow: hidden;
  -webkit-animation: start 0.3s ease-in;
  animation: start 0.3s ease-in;
}
.linear-progress-material.small {
  width: 50%;
  height: 2px;
  margin-bottom: 30px;
}
.linear-progress-material .bar {
  position: absolute;
  background: #106cc8;
  transition: transform 0.2s linear;
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 50%;
}
.linear-progress-material .bar1 {
  -webkit-animation: growBar1 2.5s infinite, moveBar1 2.5s infinite;
  animation: growBar1 3.5s infinite, moveBar1 3.5s infinite;
}
.linear-progress-material .bar2 {
  -webkit-animation: growBar2 2.5s infinite, moveBar2 2.5s infinite;
  animation: growBar2 3.5s infinite, moveBar2 3.5s infinite;
}
@-webkit-keyframes growBar1 {
  0% {
    -webkit-animation-timing-function: linear;
    animation-timing-function: linear;
    transform: scaleX(0.1);
  }
  36.6% {
    -webkit-animation-timing-function: cubic-bezier(0.33473, 0.12482, 0.78584, 1);
    animation-timing-function: cubic-bezier(0.33473, 0.12482, 0.78584, 1);
    transform: scaleX(0.1);
  }
  69.15% {
    -webkit-animation-timing-function: cubic-bezier(0.22573, 0, 0.23365, 1.37098);
    animation-timing-function: cubic-bezier(0.22573, 0, 0.23365, 1.37098);
    transform: scaleX(0.83);
  }
  100% {
    transform: scaleX(0.1);
  }
}
@keyframes growBar1 {
  0% {
    -webkit-animation-timing-function: linear;
    animation-timing-function: linear;
    transform: scaleX(0.1);
  }
  36.6% {
    -webkit-animation-timing-function: cubic-bezier(0.33473, 0.12482, 0.78584, 1);
    animation-timing-function: cubic-bezier(0.33473, 0.12482, 0.78584, 1);
    transform: scaleX(0.1);
  }
  69.15% {
    -webkit-animation-timing-function: cubic-bezier(0.22573, 0, 0.23365, 1.37098);
    animation-timing-function: cubic-bezier(0.22573, 0, 0.23365, 1.37098);
    transform: scaleX(0.83);
  }
  100% {
    transform: scaleX(0.1);
  }
}
@-webkit-keyframes moveBar1 {
  0% {
    left: -105.16667%;
    -webkit-animation-timing-function: linear;
    animation-timing-function: linear;
  }
  20% {
    left: -105.16667%;
    -webkit-animation-timing-function: cubic-bezier(0.5, 0, 0.70173, 0.49582);
    animation-timing-function: cubic-bezier(0.5, 0, 0.70173, 0.49582);
  }
  69.15% {
    left: 21.5%;
    -webkit-animation-timing-function: cubic-bezier(0.30244, 0.38135, 0.55, 0.95635);
    animation-timing-function: cubic-bezier(0.30244, 0.38135, 0.55, 0.95635);
  }
  100% {
    left: 95.44444%;
  }
}
@keyframes moveBar1 {
  0% {
    left: -105.16667%;
    -webkit-animation-timing-function: linear;
    animation-timing-function: linear;
  }
  20% {
    left: -105.16667%;
    -webkit-animation-timing-function: cubic-bezier(0.5, 0, 0.70173, 0.49582);
    animation-timing-function: cubic-bezier(0.5, 0, 0.70173, 0.49582);
  }
  69.15% {
    left: 21.5%;
    -webkit-animation-timing-function: cubic-bezier(0.30244, 0.38135, 0.55, 0.95635);
    animation-timing-function: cubic-bezier(0.30244, 0.38135, 0.55, 0.95635);
  }
  100% {
    left: 95.44444%;
  }
}
@-webkit-keyframes growBar2 {
  0% {
    -webkit-animation-timing-function: cubic-bezier(0.20503, 0.05705, 0.57661, 0.45397);
    animation-timing-function: cubic-bezier(0.20503, 0.05705, 0.57661, 0.45397);
    transform: scaleX(0.1);
  }
  19.15% {
    -webkit-animation-timing-function: cubic-bezier(0.15231, 0.19643, 0.64837, 1.00432);
    animation-timing-function: cubic-bezier(0.15231, 0.19643, 0.64837, 1.00432);
    transform: scaleX(0.57);
  }
  44.15% {
    -webkit-animation-timing-function: cubic-bezier(0.25776, -0.00316, 0.21176, 1.38179);
    animation-timing-function: cubic-bezier(0.25776, -0.00316, 0.21176, 1.38179);
    transform: scaleX(0.91);
  }
  100% {
    transform: scaleX(0.1);
  }
}
@keyframes growBar2 {
  0% {
    -webkit-animation-timing-function: cubic-bezier(0.20503, 0.05705, 0.57661, 0.45397);
    animation-timing-function: cubic-bezier(0.20503, 0.05705, 0.57661, 0.45397);
    transform: scaleX(0.1);
  }
  19.15% {
    -webkit-animation-timing-function: cubic-bezier(0.15231, 0.19643, 0.64837, 1.00432);
    animation-timing-function: cubic-bezier(0.15231, 0.19643, 0.64837, 1.00432);
    transform: scaleX(0.57);
  }
  44.15% {
    -webkit-animation-timing-function: cubic-bezier(0.25776, -0.00316, 0.21176, 1.38179);
    animation-timing-function: cubic-bezier(0.25776, -0.00316, 0.21176, 1.38179);
    transform: scaleX(0.91);
  }
  100% {
    transform: scaleX(0.1);
  }
}
@-webkit-keyframes moveBar2 {
  0% {
    left: -54.88889%;
    -webkit-animation-timing-function: cubic-bezier(0.15, 0, 0.51506, 0.40968);
    animation-timing-function: cubic-bezier(0.15, 0, 0.51506, 0.40968);
  }
  25% {
    left: -17.25%;
    -webkit-animation-timing-function: cubic-bezier(0.31033, 0.28406, 0.8, 0.73372);
    animation-timing-function: cubic-bezier(0.31033, 0.28406, 0.8, 0.73372);
  }
  48.35% {
    left: 29.5%;
    -webkit-animation-timing-function: cubic-bezier(0.4, 0.62703, 0.6, 0.90203);
    animation-timing-function: cubic-bezier(0.4, 0.62703, 0.6, 0.90203);
  }
  100% {
    left: 117.38889%;
  }
}
@keyframes moveBar2 {
  0% {
    left: -54.88889%;
    -webkit-animation-timing-function: cubic-bezier(0.15, 0, 0.51506, 0.40968);
    animation-timing-function: cubic-bezier(0.15, 0, 0.51506, 0.40968);
  }
  25% {
    left: -17.25%;
    -webkit-animation-timing-function: cubic-bezier(0.31033, 0.28406, 0.8, 0.73372);
    animation-timing-function: cubic-bezier(0.31033, 0.28406, 0.8, 0.73372);
  }
  48.35% {
    left: 29.5%;
    -webkit-animation-timing-function: cubic-bezier(0.4, 0.62703, 0.6, 0.90203);
    animation-timing-function: cubic-bezier(0.4, 0.62703, 0.6, 0.90203);
  }
  100% {
    left: 117.38889%;
  }
}
@-webkit-keyframes start {
  from {
    max-height: 0;
    opacity: 0;
  }
  to {
    max-height: 20px;
    opacity: 1;
  }
}
@keyframes start {
  from {
    max-height: 0;
    opacity: 0;
  }
  to {
    max-height: 20px;
    opacity: 1;
  }
}
@-webkit-keyframes end {
  from {
    max-height: 0;
    opacity: 0;
  }
  to {
    max-height: 2px;
    opacity: 1;
  }
}
@keyframes end {
  from {
    max-height: 0;
    opacity: 0;
  }
  to {
    max-height: 2px;
    opacity: 1;
  }
}
@-webkit-keyframes progressLinearMovement {
  0% {
    left: -100%;
  }
  50% {
    left: 100%;
  }
  100% {
    left: 100%;
  }
}
@keyframes progressLinearMovement {
  0% {
    left: -100%;
  }
  50% {
    left: 100%;
  }
  100% {
    left: 100%;
  }
}
.tabitem{
  display: inline-block;
  width: 90px;
  cursor: pointer;
  opacity: 0.5;
}
.activetab{
  opacity: 1;
}
.vl {
  border-left: 2px solid rgba(0, 0, 0, 0.12);
  height: 45px;
  display: inline-block;
  margin-right: 5px;
  margin-left: 5px;
}
.phone_number_section{
  height: 35px !important;
}
.fb-btn {
  border-radius: 7px;
  text-transform: none;
}
.vue-tel-input {
  height: 40px !important;
  font-size: 100% !important;
  border-radius: 5px !important;
}

.ft_sz_17{
  font-size: 17px !important;
}
.btn_height_50{
  height: 50px !important;
}
.fx_height_pc_tel{
  height: 40px !important;
}
.fx_height_pr_tel{
  height: 165px !important;
}

.focus-visible{
  border-bottom: 0px !important;
}
.vue-tel-input {
  border-radius: 3px;
  display: flex;
  border: 1px solid #bbb;
  text-align: left;
}
@keyframes blink {
  50% {
    border-color: #fff;
  }
}
@media screen and (max-height: 901px) {
  .ft_depend_height{
    font-size: max( 17px) !important;
  }
}
</style>
<style lang="css" scoped>
.no_discount_fb .width_fb_block{
  width: 200px !important;
  display: inline-block !important;
}
.no_discount_fb .fb-messenger-checkbox{  
  display: inline-block !important;
}
.disc_block .fb-messenger-checkbox {
  display:block !important;
}
.cursorPointer{
  cursor: pointer !Important;
}
.height_73{
  height: 73px !Important;
}
.ps_rel_100{
  position: relative;
  left:50% !important;
}
.marg_left_22{
  margin-left: 22px !important;
}
</style>